import { ipsos, supuesto } from ".";

// Lámina 79 (base 400 general / 248 con mascotas).
const P_TIENE = "¿Tiene mascotas en su hogar?";
const P_CANTIDAD = "¿Cuántas mascotas tiene?";
const P_TIPO = "¿Qué tipo de mascota tiene?";
const P_IMPORTANCIA = "¿Qué tan importante es su mascota en la familia?";
const P_FRECUENCIA = "¿Con qué frecuencia compra alimento para su mascota?";
const P_CANAL = "¿Dónde compra el alimento para su mascota?";
const P_MARCA = "¿Cuál es su marca de alimento para mascotas preferida?";

export const IPSOS_MASCOTAS = {
  penetracion: ipsos(0.616, { lamina: 79, pregunta: P_TIENE, base: 400 }),
  noPenetracion: ipsos(0.384, { lamina: 79, pregunta: P_TIENE, base: 400 }),

  cantidadMascotas: {
    una: ipsos(0.472, { lamina: 79, pregunta: P_CANTIDAD, base: 248 }),
    dos: ipsos(0.285, { lamina: 79, pregunta: P_CANTIDAD, base: 248 }),
    tres: ipsos(0.094, { lamina: 79, pregunta: P_CANTIDAD, base: 248 }),
    cuatroMas: ipsos(0.149, { lamina: 79, pregunta: P_CANTIDAD, base: 248 }),
  },

  // La pregunta de Ipsos es marca de alimento en general, no distingue perro/gato (10.1)
  tipoMascota: {
    perro: ipsos(0.711, { lamina: 79, pregunta: P_TIPO, base: 248 }),
    gato: ipsos(0.42, { lamina: 79, pregunta: P_TIPO, base: 248, nota: "multirespuesta" }),
    caballo: ipsos(0.014, { lamina: 79, pregunta: P_TIPO, base: 248, nota: "multirespuesta" }),
    conejo: ipsos(0.009, { lamina: 79, pregunta: P_TIPO, base: 248, nota: "multirespuesta" }),
    otros: ipsos(0.057, { lamina: 79, pregunta: P_TIPO, base: 248, nota: "multirespuesta" }),
  },

  importancia: {
    muyImportante: ipsos(0.879, { lamina: 79, pregunta: P_IMPORTANCIA, base: 248 }),
    bastante: ipsos(0.107, { lamina: 79, pregunta: P_IMPORTANCIA, base: 248 }),
    algo: ipsos(0.014, { lamina: 79, pregunta: P_IMPORTANCIA, base: 248 }),
  },

  // factor = veces/mes (supuesto comercial derivado de la etiqueta de frecuencia Ipsos)
  frecuenciaCompra: {
    semanal: {
      pct: ipsos(0.047, { lamina: 79, pregunta: P_FRECUENCIA, base: 248 }),
      factor: supuesto(4, { nota: "compras/mes" }),
    },
    cadaDosSemannas: {
      pct: ipsos(0.038, { lamina: 79, pregunta: P_FRECUENCIA, base: 248 }),
      factor: supuesto(2, { nota: "compras/mes" }),
    },
    mensual: {
      pct: ipsos(0.728, { lamina: 79, pregunta: P_FRECUENCIA, base: 248 }),
      factor: supuesto(1, { nota: "compras/mes" }),
    },
    cadaDosMeses: {
      pct: ipsos(0.186, { lamina: 79, pregunta: P_FRECUENCIA, base: 248 }),
      factor: supuesto(0.5, { nota: "compras/mes" }),
    },
  },

  canalCompra: {
    "Tienda de mascotas": ipsos(0.384, { lamina: 79, pregunta: P_CANAL, base: 248 }),
    Supermercado: ipsos(0.229, { lamina: 79, pregunta: P_CANAL, base: 248 }),
    Internet: ipsos(0.156, { lamina: 79, pregunta: P_CANAL, base: 248 }),
    Distribuidora: ipsos(0.069, { lamina: 79, pregunta: P_CANAL, base: 248 }),
    Veterinaria: ipsos(0.032, { lamina: 79, pregunta: P_CANAL, base: 248 }),
    Otros: ipsos(0.13, { lamina: 79, pregunta: P_CANAL, base: 248 }),
  },

  // Marca de alimento para mascotas en general — usada por perros y gatos (10.1)
  marketShareAlimento: {
    "Royal Canin": ipsos(0.112, { lamina: 79, pregunta: P_MARCA, base: 248 }),
    "Fórmula Fit": ipsos(0.089, { lamina: 79, pregunta: P_MARCA, base: 248 }),
    Purina: ipsos(0.068, { lamina: 79, pregunta: P_MARCA, base: 248 }),
    Pedigree: ipsos(0.068, { lamina: 79, pregunta: P_MARCA, base: 248 }),
    "Brit Care": ipsos(0.062, { lamina: 79, pregunta: P_MARCA, base: 248 }),
    Brawery: ipsos(0.056, { lamina: 79, pregunta: P_MARCA, base: 248 }),
    Catshow: ipsos(0.052, { lamina: 79, pregunta: P_MARCA, base: 248 }),
    Salvaje: ipsos(0.047, { lamina: 79, pregunta: P_MARCA, base: 248 }),
    Nomade: ipsos(0.04, { lamina: 79, pregunta: P_MARCA, base: 248 }),
    "Dog Chow": ipsos(0.039, { lamina: 79, pregunta: P_MARCA, base: 248 }),
    Otras: ipsos(0.367, { lamina: 79, pregunta: P_MARCA, base: 248 }),
  },
};

// Supuesto comercial, no Ipsos: distribución proporcional asumida de mascotas totales
export const PCT_PERROS_DE_MASCOTAS = supuesto(0.6, { nota: "~60% de las mascotas son perros" });
export const PCT_GATOS_DE_MASCOTAS = supuesto(0.35, { nota: "~35% de las mascotas son gatos" });

// Distribución por tamaño de perro — supuesto comercial, no Ipsos ("estimación estándar de mercado")
export const DISTRIBUCION_TAMANO_PERROS = {
  grande: supuesto(0.25, { nota: "estimación estándar de mercado" }),
  mediano: supuesto(0.45, { nota: "estimación estándar de mercado" }),
  chico: supuesto(0.3, { nota: "estimación estándar de mercado" }),
};

// Consumo mensual por tamaño de perro (kg de alimento) — supuesto comercial, no Ipsos
// (recomendaciones fabricantes)
export const CONSUMO_PERROS = {
  grande: { peso: "25-35 kg", consumoDiario: 0.5, consumoMensual: 15, descripcion: "Labrador, Pastor Alemán" },
  mediano: { peso: "10-25 kg", consumoDiario: 0.3, consumoMensual: 9, descripcion: "Beagle, Cocker" },
  chico: { peso: "< 10 kg", consumoDiario: 0.17, consumoMensual: 5, descripcion: "Chihuahua, Yorkshire" },
};

// Consumo mensual gatos (kg de alimento) — supuesto comercial, no Ipsos
export const CONSUMO_GATOS = {
  adulto: { peso: "3-5 kg", consumoDiario: 0.06, consumoMensual: 1.8, descripcion: "Gato adulto promedio" },
};

// Precios de referencia por kg (CLP) — supuesto comercial, no Ipsos
// (basado en Royal Canin ~$4.500/kg, Pro Plan ~$5.200/kg)
export const PRECIOS_ALIMENTO_DEFAULT = {
  perros: {
    superpremium: { nombre: "Super Premium", precioKg: 5000 },
    premium: { nombre: "Premium", precioKg: 3500 },
    estandar: { nombre: "Estándar", precioKg: 2000 },
  },
  gatos: {
    superpremium: { nombre: "Super Premium", precioKg: 6000 },
    premium: { nombre: "Premium", precioKg: 4000 },
    estandar: { nombre: "Estándar", precioKg: 2500 },
  },
};

export const ESCENARIOS_CAPTACION_MASCOTAS = [
  supuesto(2, { nota: "escenario de captación de mercado" }),
  supuesto(4, { nota: "escenario de captación de mercado" }),
  supuesto(6, { nota: "escenario de captación de mercado" }),
  supuesto(8, { nota: "escenario de captación de mercado" }),
  supuesto(10, { nota: "escenario de captación de mercado" }),
];
